import { useMediaQuery } from "@mui/material";

type PageOrientation = "portrait" | "landscape";

export const usePageOrientation = (): PageOrientation => {
  return useMediaQuery("(orientation: portrait)") ? "portrait" : "landscape";
};
